export interface GridModel {
    Data: any;
    Total: number;
}

export interface SearchGridModel {
    filters: any;
    sort: SortField;
    page: number;
    take: number
}

export interface SortField {
    fieldName: string;
    direction: string;
}

export interface SelectedField {
    id: number;
    value: string;
    isAllSelected?: boolean
}

export interface GridActions {
    name: string,
    event: string,
    icon: string
}

export interface FilterValue {
    displayValue: string,
    actualValue: string
}

export interface GridColumnConfig {
    columnName: string,
    displayName: string,    
    filterName?: string,
    position?: number,  
    isVisible?: boolean,    
    isEnabled?: boolean,
    isSortable?: boolean,
    defaultSortOrder?: SortOrder,
    columnType?: ColumnType,
    filterType?: ColumnType,
    columnSize?: number,
    sizeUnit?: string,   
    routeUrl?: string,
    routeParams?: string[],
    actions?: GridActions[],
    icon?: string,
    columnNameForLink?: string,
    columnAlign?: string,
    isReorderColumns: boolean,
    isSticky?: boolean,
    isStickyEnd?: boolean
}

export enum SortOrder {  
    ASC = 'asc',
    DESC = 'desc'
}

export declare type SortDirection = 'asc' | 'desc' | '';

export enum ColumnType {
    STRING = 'string',
    INTEGER = 'integer',
    DECIMAL = 'decimal',
    DATETIME = 'date',
    BOOL = 'bool',
    CHECKBOX = 'checkbox',
    ACTIONS = 'action',
    MONEY = 'money',
    DATE = 'date',
    LINK = 'link',
    DATEPICKER = 'datepicker',
    DATEPICKER_CUSTOM = 'datepicker-custom'
}

export const PAGE_SIZE_OPTIONS: number[] = [5, 10, 25, 50, 100];
export const PAGESIZE: number = 10;
export const PAGE: number = 0;
export const DATE_FORMAT: string = 'MM-dd-yyyy';
export const DATE_FORMAT_SAVE: string = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT_SAVE: string = 'yyyy-MM-dd HH:mm:ss';
export const DATE_TIME_FORMAT: string = 'MM-dd-yyyy';

export const GridActionColumn = [    
    {
        "name": "Edit",
        "event": "edit",
        "icon": "edit"
    },
    {
        "name": "Delete",
        "event": "delete",
        "icon": "delete"
    },
    {
        "name": "Copy",
        "event": "copy",
        "icon": "file_copy"
    }
]


export enum ActionType {
    EDIT = 'edit',
    DELETE = 'delete',
    VIEW = 'view'    
}

export interface RouteQueryConfig {
    data: any,
    routeUrl: string;
}
